export default __webpack_public_path__ + "static/media/fire.568e338c.png";